import { render, staticRenderFns } from "./PpPriority_v2.vue?vue&type=template&id=f5c4888a&scoped=true&"
import script from "./PpPriority_v2.vue?vue&type=script&lang=js&"
export * from "./PpPriority_v2.vue?vue&type=script&lang=js&"
import style0 from "./PpPriority_v2.vue?vue&type=style&index=0&id=f5c4888a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c4888a",
  null
  
)

export default component.exports